import { useLocation } from "react-router-dom";
import HeaderDark from "./HeaderDark";
import Header from "./Header";

const DARK_PATHS = ["/", "/about", "/how-it-works", "/faq"];
// Known light paths — every other route gets light header except the dark marketing pages
const KNOWN_PATHS = [
  ...DARK_PATHS,
  "/qualify", "/free-results", "/results", "/admin",
  "/disclaimer", "/login", "/signup", "/forgot-password",
  "/reset-password", "/verify-email", "/dashboard",
  "/blog", "/privacy", "/contact", "/terms",
  "/partners/verify", "/partners/verify/demo", "/partners/portal",
  "/partners/lend-demo", "/book-demo",
];

export default function HeaderSwitcher() {
  const { pathname } = useLocation();
  // Dark header on landing-style pages + unknown routes (404 also gets dark hero)
  const useDark =
    DARK_PATHS.includes(pathname) ||
    (!KNOWN_PATHS.some((p) => pathname === p || pathname.startsWith(p + "/")));
  return useDark ? <HeaderDark /> : <Header />;
}
